import { useState, type FormEvent } from "react";
import { Button } from "@/components/ui/Button";
import { Input } from "@/components/ui/Input";
import { SsoApiError, resolveSsoWorkspace } from "./api";

export function SsoLoginForm({ onError }: { onError?: (message: string) => void } = {}): JSX.Element {
  const [workspace, setWorkspace] = useState("");
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setError(null);
    if (!workspace.trim()) {
      setError("ワークスペースIDを入力してください");
      return;
    }
    setPending(true);
    try {
      const resolved = await resolveSsoWorkspace(workspace.trim());
      window.location.assign(resolved.url);
    } catch (err) {
      const message = err instanceof SsoApiError ? err.message : "SSOを開始できませんでした";
      setError(message);
      onError?.(message);
    } finally {
      setPending(false);
    }
  };

  return (
    <form onSubmit={(event) => void submit(event)} className="space-y-3">
      <p className="text-sm text-fg-secondary">会社のSSOは、IdPのメールだけでは既存アカウントに結び付きません。初回はメール/Passkeyで入った本人が紐付けます。</p>
      <label className="block text-sm" htmlFor="sso-workspace">ワークスペース</label>
      <Input id="sso-workspace" value={workspace} onChange={(event) => setWorkspace(event.target.value)} placeholder="example" autoComplete="organization" />
      {error && <p role="alert" className="text-sm text-danger">{error}</p>}
      <Button type="submit" disabled={pending || !workspace.trim()}>{pending ? "移動しています…" : "組織のSSOで続ける"}</Button>
    </form>
  );
}
